<template>
  <div>
    <div class="d-flex" id="wrapper">
      <!-- Sidebar -->
      <SideBar/>
      <!-- /#sidebar-wrapper -->
      <!-- Page Content -->
      <div id="page-content-wrapper">
        <nav style="justify-content:flex-start;" class="navbar navbar-expand-lg navbar-light bg-light border-bottom floating">
          <div>
            <button class="btn btn-outline" id="menu-toggle" @click="sidebar"><span class="navbar-toggler-icon"></span>
            </button>

            <button style="color: rgba(0,0,0,.5);border-color: rgba(0,0,0,.1);" class="btn btn-outline navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
              <span style="padding-top:0.5em;"><i class="fas fa-user-alt"></i><span class="account-div"></span><i class="fas fa-angle-down"></i></span>
            </button>
          </div>
          <div class="d-flex">
            <!-- <i class="fas fa-home text-muted hover-cursor" @click="toPage('/dashboard')"></i> -->
            <p class="text-primary mb-0 hover-cursor">&nbsp; Order Tag</p>
          </div>
          <div class="collapse navbar-collapse" id="navbarSupportedContent">
            <ul class="navbar-nav ml-auto mt-2 mt-lg-0">
              <li class="nav-item dropdown">
                <a class="nav-link dropdown-toggle" href="#" id="navbarDropdown" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                  {{ admin }}
                </a>
                <div class="dropdown-menu dropdown-menu-right" aria-labelledby="navbarDropdown">
                  <a class="dropdown-item link" @click="toPage('/password')"> <i class="fas fa-cog"></i><span class="right-dropdown">Change Password</span></a>
                  <a class="dropdown-item link" @click="handleLogout"><i class="fas fa-sign-out-alt"></i><span class="right-dropdown">Logout</span></a>
                </div>
              </li>
            </ul>
          </div>
        </nav>
        <!-- Table 1 -->
        <div class="container-fluid">
          <div class="row">
            <div class="col-md-12 grid-margin stretch-card card-div">
              <div class="container">
                <h5 class="card-title mb-4"> Order Tag Category </h5>
                <div class="search-table container-fluid">
                  <div class="row">
                    <div class="col-lg-3 col-sm mobile-div">
                      <input type="text" class="name-search form-control form-control-sm" v-model="searchCategoryName" placeholder="Tag Category">
                    </div>
                    <div class="col-lg-2 col-sm mobile-div">
                      <button class="btn btn-primary btn-sm" style='margin-top:5px;' @click="searchData"> Search </button>
                    </div>
                  </div>
                </div>                           
                <button v-if="editTag" class="btn btn-primary btn-sm mb-1"  @click="openModal('AddCategory', false)"> Add New Category </button>                              
                <table class="table table-sm table-bordered table-striped table-responsive-sm">
                  <thead class="">
                    <tr>
                      <th>Category Name</th>
                      <th>Default Color</th>
                      <th v-if="editTag">Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-if="loadingCategoryTable === true">
                      <td colspan="3" class="text-center"><img src="~@/assets/images/load-button.gif"></td>
                    </tr>
                    <tr v-for="data in dataCategory" v-else  :key = data.categoryId>
                      <td>{{ data.categoryName }}</td>
                      <td>{{ data.categoryDefaultColor }}</td>
                      <td v-if="editTag">
                        <button class="btn btn-warning btn-sm" @click="openModal('EditCategory', false, data, data.categoryId, 'category')"> Edit </button>
                        <button class="btn btn-danger btn-sm" @click="openModal('DeleteCategory',false, data, data.categoryId, 'category')"> Delete </button>
                      </td>
                    </tr>
                    <tr v-if="totalCategoryData === 0 && loadingCategoryTable === false">
                      <td colspan="3" class="text-center"> Data Not Available</td>
                    </tr>
                  </tbody>
                </table>
                <div id="wrapperr">
                  <div id="c1">
                    <div class="alignLeft total-data">
                      Total Data {{ totalCategoryData }} 
                    </div>
                  </div>
                  <div id="c2">
                    <div class="pagination p8 alignRight">
                      <ul>
                        <a class="is-active link" @click="toDataPage(parseInt(currentCategoryPage)-1, 'category')" v-if="currentCategoryPage != 1"><li>{{'<'}}</li></a>
                        <a class="page"><li>{{ currentCategoryPage }} of {{ totalCategoryPage }} page</li></a>
                        <a class="is-active link" @click="toDataPage(parseInt(currentCategoryPage)+1, 'category')" v-if="currentCategoryPage != totalCategoryPage"><li>{{'>'}}</li></a>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="container">
          <hr color="black" align="center" size="2px" >
        </div>
        
        <!-- Table 2 -->
        <div class="container-fluid">
          <div class="row">
            <div class="col-md-12 grid-margin stretch-card card-div">
              <div class="container">
                <h5 class="card-title mb-4"> Order Tag </h5>
                <div class="search-table container-fluid" style="height: 49px">
                  <div class="row">
                    <div class="col-lg-3 col-sm mobile-div">
                      <input type="text" class="name-search form-control w-100" v-model="searchTagName" placeholder="Tag Name">
                    </div>
                    <div  class="col-lg-4 col-sm mobile-div" >
                      <multiselect  v-model="selectedFilterTagCategory" :options="allCategoryData" label="categoryName" :allow-empty="true" aria-placeholder="Filter Category" :multiple="true" :select-label="''" :deselect-label="''" track-by="categoryName" :close-on-select="false"></multiselect>
                    </div>
                    <div class="col-lg-2 col-sm mobile-div">
                      <button class="btn btn-primary btn-sm" style='margin-top:5px;' @click="searchData"> Search </button>
                    </div>
                  </div>
                </div>
                <button v-if="editTag" class="btn btn-primary btn-sm mb-1"  @click="openModal('AddTag', true)"> Create </button>
                
                <table class="table table-sm table-bordered table-striped table-responsive-sm">
                  <thead class="">
                    <tr>
                      <th>Tag Name</th>
                      <th>Category</th>
                      <th>Color</th>
                      <th v-if="editTag">Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-if="loadingTagTable === true">
                      <td colspan="4" class="text-center"><img src="~@/assets/images/load-button.gif"></td>
                    </tr>
                    <tr v-for="data in dataTag" v-else  :key = data.tagId>
                      <td>{{ data.label }}</td>
                      <td>{{data.category.categoryName}}</td>
                      <td>{{ data.colorHex }}</td>
                      <td v-if="editTag">
                        <button class="btn btn-warning btn-sm" @click="openModal('EditTag',true, data, data.tagId, 'tag')"> Edit </button>
                        <button class="btn btn-danger btn-sm" @click="openModal('DeleteTag',true, data, data.tagId, 'tag')"> Delete </button>
                      </td>
                    </tr>
                    <tr v-if="totalData === 0 && loadingTagTable === false">
                      <td colspan="4" class="text-center"> Data Not Available</td>
                    </tr>
                  </tbody>
                </table>
                <div id="wrapperr">
                  <div id="c1">
                    <div class="alignLeft total-data">
                      Total Data {{ totalData }} 
                    </div>
                  </div>
                  <div id="c2">
                    <div class="pagination p8 alignRight">
                      <ul>
                        <a class="is-active link" @click="toDataPage(parseInt(currentPage)-1 , 'tag')" v-if="currentPage != 1"><li>{{'<'}}</li></a>
                        <a class="page"><li>{{ currentPage }} of {{ totalPage }} page</li></a>
                        <a class="is-active link" @click="toDataPage(parseInt(currentPage)+1 , 'tag')" v-if="currentPage != totalPage"><li>{{'>'}}</li></a>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!--  -->
      </div>
      <!-- /#page-content-wrapper -->
      <!-- TAG MODALS -->
      <!-- modalAddTag -->
      <div class="modal fade" id="modalAddTag" role="dialog">
        <div class="modal-dialog modal-dialog-centered">
            <!-- Modal content-->
            <div class="modal-content">
                <div class="modal-header">
                    <div class="change-title">
                        <h4 class="modal-title">Add Tag </h4>
                    </div>
                    <button type="button" class="close" data-dismiss="modal">&times;</button>
                </div>
                <div class="modal-body">
                    <div class="one-line">
                        <label class="ol-labelCategory">Category</label>
                        <label class="ol-titik2category">:</label>
                        <multiselect v-model="addTagCategory"  @input="adjustTagColor()" :options="tagCategoryOptions" label="categoryName" :allow-empty="false"></multiselect>
                    </div>
                    <div v-if="addTagCategory.categoryName === 'Others'">
                      <div class="one-line">
                        <label class="ol-label"> New Category </label>
                        <label class="ol-titik2">:</label>
                        <input type="text" name="new-category" placeholder="New tag category name" class="form-control" v-model.trim="newTagCategory">
                      </div>
                      <div class="one-line">
                          <label class="ol-label"> Default Color </label>
                          <label class="ol-titik2">:</label>
                          <input type="text" name="default-color"  @input="adjustTagColor(true)" placeholder="Hexcolor code. ex: #FFFFFF" class="form-control"  v-model.trim="newTagCategoryDefaultColor">
                      </div>
                    </div>
                     <div class="one-line">
                        <label class="ol-label"> Tag Name </label>
                        <label class="ol-titik2">:</label>
                        <!-- <input type="text" name="name" class="form-control" placeholder="New tag name" :class="{ 'form-control border-red' : $v.addTagName.$error}" v-model.trim="$v.addTagName.$model"> -->
                        <input type="text" name="name" class="form-control" placeholder="New tag name" v-model.trim="addTagName">
                    </div>
                    <div class="one-line">
                        <label class="ol-label"> Color </label>
                        <label class="ol-titik2">:</label>
                        <!-- <input type="text" name="color" class="form-control" placeholder="Hexcolor code. ex: #FFFFFF" :class="{ 'form-control border-red' : $v.addTagColor.$error}" v-model.trim="$v.addTagColor.$model"> -->
                        <input type="text" name="color" class="form-control" placeholder="Hexcolor code. ex: #FFFFFF" v-model.trim="addTagColor">
                    </div>
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-danger btn-sm" data-dismiss="modal">Cancel</button>
                    <button type="button" class="btn btn-primary btn-sm" @click="validateForm('create',true)" v-if="loadingButtonAdd == false">Save</button>
                    <button type="button" class="btn btn-primary btn-sm" disabled v-else><img src="~@/assets/images/2.gif" style="height: 24px;">Saving</button>
                </div>
            </div>
        </div>
      </div>
      <!-- endModal -->
      <!-- modalEditTag -->
      <div class="modal fade" id="modalEditTag" role="dialog">
        <div class="modal-dialog modal-dialog-centered">
            <!-- Modal content-->
       <div class="modal-content">
                <div class="modal-header">
                    <div class="change-title">
                        <h4 class="modal-title">Edit Tag </h4>
                    </div>
                    <button type="button" class="close" data-dismiss="modal">&times;</button>
                </div>
                <div class="modal-body">
                    <div class="one-line">
                        <label class="ol-labelCategory">Category</label>
                        <label class="ol-titik2category">:</label>
                        <multiselect v-model="addTagCategory"  @input="adjustTagColor()" :options="tagCategoryOptions" label="categoryName" :allow-empty="false"></multiselect>
                    </div>
                    <div v-if="addTagCategory.categoryName === 'Others'">
                      <div class="one-line">
                        <label class="ol-label"> New Category </label>
                        <label class="ol-titik2">:</label>
                        <input type="text" name="new-category" placeholder="New tag category name" class="form-control"  v-model.trim="newTagCategory">
                      </div>
                      <div class="one-line">
                          <label class="ol-label"> Default Color </label>
                          <label class="ol-titik2">:</label>
                          <input type="text" name="default-color" @input="adjustTagColor(true)" placeholder="Hexcolor code. ex: #FFFFFF" class="form-control"  v-model.trim="newTagCategoryDefaultColor">
                      </div>
                    </div>
                    <div class="one-line">
                        <label class="ol-label"> Tag Name </label>
                        <label class="ol-titik2">:</label>
                        <!-- <input type="text" name="name" class="form-control" :class="{ 'form-control border-red' : $v.addTagName.$error}" v-model.trim="$v.addTagName.$model"> -->
                        <input type="text" name="name" class="form-control" v-model.trim="addTagName">
                    </div>
                    <div class="one-line">
                        <label class="ol-label"> Color </label>
                        <label class="ol-titik2">:</label>
                        <!-- <input type="email" name="color" class="form-control" :class="{ 'form-control border-red' : $v.addTagColor.$error}" v-model.trim="$v.addTagColor.$model"> -->
                        <input type="email" name="color" class="form-control" v-model.trim="addTagColor">
                    </div>
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-danger btn-sm" data-dismiss="modal">Cancel</button>
                    <button type="button" class="btn btn-primary btn-sm" @click="validateForm('edit',true)" v-if="loadingButtonAdd == false">Save</button>
                    <button type="button" class="btn btn-primary btn-sm" disabled v-else><img src="~@/assets/images/2.gif" style="height: 24px;">Saving</button>
                </div>
            </div>
        </div>
      </div>
      <!-- endModal -->

       <!-- modal delete tag -->
      <div class="modal fade" id="modalDeleteTag" role="dialog">
        <div class="modal-dialog modal-dialog-centered">
            <!-- Modal content-->
       <div class="modal-content">
                <div class="modal-header">
                    <div class="change-title">
                        <h4 class="modal-title">Delete Tag </h4>
                    </div>
                    <button type="button" class="close" data-dismiss="modal">&times;</button>
                </div>
                <div class="modal-body">
                     <div class="one-line">
                        <label> Are you sure you want to remove the "{{selectedTag.label}}" Tag ? </label>
                    </div>
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-danger btn-sm" data-dismiss="modal">Cancel</button>
                    <button type="button" class="btn btn-primary btn-sm" @click="validateForm('delete',true)" v-if="loadingButtonAdd == false">Delete</button>
                    <button type="button" class="btn btn-primary btn-sm" disabled v-else><img src="~@/assets/images/2.gif" style="height: 24px;">Deleting</button>
                </div>
            </div>
        </div>
      </div>
      <!-- endModal -->
      <!-- END OF TAG MODALS -->

      <!-- CATEGORY MODALS -->
      <!-- modalAddCategory -->
      <div class="modal fade" id="modalAddCategory" role="dialog">
        <div class="modal-dialog modal-dialog-centered">
            <!-- Modal content-->
            <div class="modal-content">
                <div class="modal-header">
                    <div class="change-title">
                        <h4 class="modal-title">Add New Category </h4>
                    </div>
                    <button type="button" class="close" data-dismiss="modal">&times;</button>
                </div>
                <div class="modal-body">
                      <div class="one-line">
                        <label class="ol-label"> New Category </label>
                        <label class="ol-titik2">:</label>
                        <!-- <input type="text" name="new-category" placeholder="New tag category name" class="form-control" :class="{ 'form-control border-red' : $v.addCategoryName.$error}" v-model.trim="$v.addCategoryName.$model"> -->
                        <input type="text" name="new-category" placeholder="New tag category name" class="form-control" v-model.trim="addCategoryName">
                      </div>
                      <div class="one-line">
                          <label class="ol-label"> Default Color </label>
                          <label class="ol-titik2">:</label>
                          <!-- <input type="text" name="default-color" placeholder="Hexcolor code. ex: #FFFFFF" class="form-control" :class="{ 'form-control border-red' : $v.addCategoryDefaultColor.$error}" v-model.trim="$v.addCategoryDefaultColor.$model"> -->
                          <input type="text" name="default-color" placeholder="Hexcolor code. ex: #FFFFFF" class="form-control" v-model.trim="addCategoryDefaultColor">
                      </div>
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-danger btn-sm" data-dismiss="modal">Cancel</button>
                    <button type="button" class="btn btn-primary btn-sm" @click="validateForm('create',false)" v-if="loadingButtonAdd == false">Save</button>
                    <button type="button" class="btn btn-primary btn-sm" disabled v-else><img src="~@/assets/images/2.gif" style="height: 24px;">Saving</button>
                </div>
            </div>
        </div>
      </div>
      <!-- endModal -->
      <!-- modalEditCategory -->
      <div class="modal fade" id="modalEditCategory" role="dialog">
        <div class="modal-dialog modal-dialog-centered">
            <!-- Modal content-->
       <div class="modal-content">
                <div class="modal-header">
                    <div class="change-title">
                        <h4 class="modal-title">Edit Category </h4>
                    </div>
                    <button type="button" class="close" data-dismiss="modal">&times;</button>
                </div>
                <div class="modal-body">
                    <div class="one-line">
                        <label class="ol-label"> Category </label>
                        <label class="ol-titik2">:</label>
                        <!-- <input type="text" name="category-name" class="form-control" :class="{ 'form-control border-red' : $v.addCategoryName.$error}" v-model.trim="$v.addCategoryName.$model"> -->
                        <input type="text" name="category-name" class="form-control" v-model.trim="addCategoryName">
                    </div>
                    <div class="one-line">
                        <label class="ol-label"> Default Color </label>
                        <label class="ol-titik2">:</label>
                        <!-- <input type="email" name="default-color" class="form-control" :class="{ 'form-control border-red' : $v.addCategoryDefaultColor.$error}" v-model.trim="$v.addCategoryDefaultColor.$model"> -->
                        <input type="email" name="default-color" class="form-control" v-model.trim="addCategoryDefaultColor">
                    </div>
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-danger btn-sm" data-dismiss="modal">Cancel</button>
                    <button type="button" class="btn btn-primary btn-sm" @click="validateForm('edit',false)" v-if="loadingButtonAdd == false">Save</button>
                    <button type="button" class="btn btn-primary btn-sm" disabled v-else><img src="~@/assets/images/2.gif" style="height: 24px;">Saving</button>
                </div>
            </div>
        </div>
      </div>
      <!-- endModal -->

       <!-- modal delete Category -->
      <div class="modal fade" id="modalDeleteCategory" role="dialog">
        <div class="modal-dialog modal-dialog-centered">
            <!-- Modal content-->
       <div class="modal-content">
                <div class="modal-header">
                    <div class="change-title">
                        <h4 class="modal-title">Delete Category </h4>
                    </div>
                    <button type="button" class="close" data-dismiss="modal">&times;</button>
                </div>
                <div class="modal-body">
                     <div class="one-line">
                        <label> Are you sure you want to remove the "{{selectedCategory.categoryName}}" from order tag categories ? </label>
                    </div>
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-danger btn-sm" data-dismiss="modal">Cancel</button>
                    <button type="button" class="btn btn-primary btn-sm" @click="validateForm('delete',false)" v-if="loadingButtonAdd == false">Delete</button>
                    <button type="button" class="btn btn-primary btn-sm" disabled v-else><img src="~@/assets/images/2.gif" style="height: 24px;">Deleting</button>
                </div>
            </div>
        </div>
      </div>
      <!-- endModal -->
      <!-- END OF CATEGORY MODALS -->

    </div>
  </div>
</template>

<script>
import swal from 'sweetalert'
import SideBar from '../SideBar'
import { required } from 'vuelidate/lib/validators'
import Multiselect from "vue-multiselect";
import "vue-multiselect/dist/vue-multiselect.min.css";
import vueSelect from 'vue-select'
import 'vue-select/dist/vue-select.css';
export default {
  name: 'LesseeTagPage',
  components:{
    SideBar,
    Multiselect,
    vueSelect
  },
  data () {
    return {
      spaceRegex: /[\u00A0\uFEFF\u202F]/g,
      admin:"",
      permission:[],
      editTag:false,
      dataTag: [],
      // Tag
      totalPage:0,
      totalData:0,
      currentPage:1,
      // End Of Tag
      // category
      dataCategory: [],// for table data
      allCategoryData:[], //untuk keperluan form
      tagCategoryOptions:[], 
      addCategoryName:'',
      addCategoryDefaultColor:'',
      selectedFilterTagCategory:[],
      selectedCategory:{},
      searchCategoryName:'',
      totalCategoryPage:0,
      totalCategoryData:0,
      currentCategoryPage:1,
      // End Of category
      itemPerPage:10,
      loadingTagTable: true,
      loadingCategoryTable:true,
      loadingButtonAdd:false,
      searchTagName:"",
      addTagName:"",
      addTagCategory:'',
      newTagCategory:'',
      newTagCategoryDefaultColor:'',
      addTagColor:"",
      selectedTag : {}, 
      // Finance Category and Tag ID
      financeCategory:[2,9,10,11,12,14,15,16,17,18],
      financeTag:[4,5,6,8,9,10,11,13,15,17,94,102,104,105,106,107,119,152,153,154,155,156,157,158,159,160,161,162,163,164,165,166,167]
    }
  },
  // validations: {
  //   addTagName: {
  //     required
  //   },
  //   addTagCategory: {
  //     required
  //   },
  //   addTagColor: {
  //     required,
  //   },
  //   addCategoryName: {
  //     required,
  //   },
  //   addCategoryDefaultColor : {
  //     required,
  //   }
  // },
  methods: {
    adjustTagColor(isNewTag) {
      let color = ""
      if(isNewTag){
        color = this.newTagCategoryDefaultColor
      } else {
        color= this.addTagCategory.categoryDefaultColor
      }
      this.addTagColor = color
    },
    validateForm(actionType,isManipulateTag){
      if(actionType != 'delete') {
        const colorRegex = /^#([A-Fa-f0-9]{6}|[A-Fa-f0-9]{3})$/;
        const textRegex = /(.|\s)*\S(.|\s)*/;
        let isError = false
        let errorMsg = '' 
        
          if(isManipulateTag) { // untuk add/edit tag
            if(!textRegex.test(this.addTagCategory)) {
              isError = true
              errorMsg = "Tag Category can't be empty"
            } 
            if(!textRegex.test(this.addTagName)) {
              isError = true
              errorMsg = "Text field must be filled"
            } 
             
            if(!textRegex.test(this.addTagColor)) {
              errorMsg = "Color field must be filled"
            } 

            if(!colorRegex.test(this.addTagColor)) {
              isError = true
              errorMsg = "Color field must be filled with hexadecimal color code"
            } 
            
            if (this.addTagCategory.categoryName == 'Others'){
              if(!this.newTagCategoryDefaultColor) {
                isError = true
                errorMsg = "Category Default Color field must be filled"
              }
              if (!colorRegex.test(this.newTagCategoryDefaultColor)){
                isError = true
                errorMsg = "Category Default Color field must be filled with hexadecimal color code"
              }
              if(!this.newTagCategory) {
                isError = true
                errorMsg = "New Category field must be filled"
              }
            }  
            
            if(isError) {
              swal("Sorry", errorMsg, "error", {
                      button: "Ok",
                  })
            } else{
              if(actionType == 'create') {
                this.submitAddTag()
              } else {
                this.submitEditTag()
              }  
            }

          } else { // untuk add atau edit Category
          
            if(!this.addCategoryDefaultColor) {
              isError = true
              errorMsg = "Category Default Color field must be filled"
            }
            if (!colorRegex.test(this.addCategoryDefaultColor)){
              isError = true
              errorMsg = "Category Default Color field must be filled with hexadecimal color code"
            }
            if(!this.addCategoryName) {
              isError = true
              errorMsg = "Category field must be filled"
            }

            if(isError) {
              swal("Sorry", errorMsg, "error", {
                      button: "Ok",
                  })
            } else {
              if(actionType == 'create') {
                this.submitAddCategory()
              } else {
                this.submitEditCategory()
              } 
            }
          }
        
      } else {
          if(isManipulateTag) {
             this.deleteTag()
          } else {
            this.deleteCategory()
          }
         
      }
    },
    submitAddTag(){
      this.loadingButtonAdd = true
        this.$http.post(process.env.CREATE_TAG,{
          label: this.addTagName.replace(this.spaceRegex, ' '),
          colorHex: this.addTagColor.replace(this.spaceRegex, ' '), 
          categoryId: this.addTagCategory.categoryId,
          categoryName: this.newTagCategory.replace(this.spaceRegex, ' '),
          categoryDefaultColor: this.newTagCategoryDefaultColor.replace(this.spaceRegex, ' '),
          target: "ORDER"
        },{
          headers: {'Asani-Token':localStorage.getItem('jwt')}
        })
        .then(response => {
          if (response.data.status !== 200) {
            swal("Sorry", response.data.message, "error", {
              button: "Ok",
            })
          }else{
            $('#modalAddTag').modal('hide')
            swal("Success", response.data.message, "success", {
              button: "Ok",
            })
            this.getTag()
            this.getTagCategory()
          }
          this.loadingButtonAdd = false
      })
      .catch(error => {
        swal("Sorry", error.response.data.message, "error", {
          button: "Ok",
        }).then(v => {
          if(error.response.data.status == 401) {
            this.handleLogout()
          }
        })
      })
    },
    submitAddCategory(){
      this.loadingButtonAdd = true
        this.$http.post(process.env.CREATE_TAG_CATEGORY,{
          categoryName: this.addCategoryName.replace(this.spaceRegex, ' '),
          categoryDefaultColor: this.addCategoryDefaultColor.replace(this.spaceRegex, ' '),
          target: "ORDER"
        },{
          headers: {'Asani-Token':localStorage.getItem('jwt')}
        })
        .then(response => {
          if (response.data.status !== 200) {
            swal("Sorry", response.data.message, "error", {
              button: "Ok",
            })
          }else{
            $('#modalAddCategory').modal('hide')
            swal("Success", response.data.message, "success", {
              button: "Ok",
            })
            this.getTagCategory()
          }
          this.loadingButtonAdd = false
      })
      .catch(error => {
        swal("Sorry", error.response.data.message, "error", {
          button: "Ok",
        }).then(v => {
          if(error.response.data.status == 401) {
            this.handleLogout()
          }
        })
      })
    },
    submitEditTag(){
      this.loadingButtonAdd = true
        this.$http.post(process.env.EDIT_TAG,{
            tagId : this.selectedTag.tagId,
            label: this.addTagName.replace(this.spaceRegex, ' '),
            colorHex: this.addTagColor.replace(this.spaceRegex, ' '),
            categoryId: this.addTagCategory.categoryId,
            categoryName: this.newTagCategory.replace(this.spaceRegex, ' '),
            categoryDefaultColor: this.newTagCategory.replace(this.spaceRegex, ' '),
            target: "ORDER"
        },{
          headers: {'Asani-Token':localStorage.getItem('jwt')}
        })
        .then(response => {
          if (response.data.status == 400) {
            swal("Sorry", "tag already exists", "error", {
              button: "Ok",
            })
          }else{
            $('#modalEditTag').modal('hide')
            swal("Success", response.data.message, "success", {
              button: "Ok",
            })
            this.getTag()
            this.getTagCategory()
          }
          this.loadingButtonAdd = false
      })
      .catch(error => {
        swal("Sorry", error.response.data.message, "error", {
          button: "Ok",
        }).then(v => {
          if(error.response.data.status == 401) {
            this.handleLogout()
          }
        })
      })
    },
    submitEditCategory(){
      this.loadingButtonAdd = true
        this.$http.post(process.env.EDIT_TAG_CATEGORY,{
            categoryId : this.selectedCategory.categoryId,
            categoryName: this.addCategoryName.replace(this.spaceRegex, ' '),
            categoryDefaultColor: this.addCategoryDefaultColor.replace(this.spaceRegex, ' '), 
            target:"ORDER"
        },{
          headers: {'Asani-Token':localStorage.getItem('jwt')}
        })
        .then(response => {
          if (response.data.status !== 200) {
            swal("Sorry", "tag already exists", "error", {
              button: "Ok",
            })
          }else{
            $('#modalEditCategory').modal('hide')
            swal("Success", response.data.message, "success", {
              button: "Ok",
            })
            this.getTagCategory()
          }
          this.loadingButtonAdd = false
      })
      .catch(error => {
        swal("Sorry", error.response.data.message, "error", {
          button: "Ok",
        }).then(v => {
          if(error.response.data.status == 401) {
            this.handleLogout()
          }
        })
      })
    },
    deleteTag() {
      this.loadingButtonAdd = true
        this.$http.post(process.env.DELETE_TAG,{
            tagId : this.selectedTag.tagId, 
        },{
          headers: {'Asani-Token':localStorage.getItem('jwt')}
        })
        .then(response => {
          if (response.data.status == 400) {
            swal("Sorry", response.data.message, "error", {
              button: "Ok",
            })
          } else if(response.data.status != 200) {
            $('#modalDeleteTag').modal('hide')
            swal("Sorry", 'Tag is in use. Remove tag from order first', "error", {
              button: "Ok",
            })
          } else{
            $('#modalDeleteTag').modal('hide')
            swal("Success", response.data.message, "success", {
              button: "Ok",
            })
            this.getTag()
          }
          this.loadingButtonAdd = false
      })
      .catch(error => {
        swal("Sorry", error.response.data.message, "error", {
          button: "Ok",
        }).then(v => {
          if(error.response.data.status == 401) {
            this.handleLogout()
          }
        })
      })
    },
    deleteCategory() {
      this.loadingButtonAdd = true
        this.$http.post(process.env.DELETE_TAG_CATEGORY,{
            categoryId : this.selectedCategory.categoryId,
        },{
          headers: {'Asani-Token':localStorage.getItem('jwt')}
        })
        .then(response => {
          if (response.data.status == 400) {
            swal("Sorry", response.data.message, "error", {
              button: "Ok",
            })
          } else if(response.data.status != 200) {
            $('#modalDeleteCategory').modal('hide')
            swal("Sorry", 'Tag Category is in use.Remove order tag with "'+this.selectedCategory.categoryName+'" category first', "error", {
              button: "Ok",
            })
          } else{
            $('#modalDeleteCategory').modal('hide')
            swal("Success", response.data.message, "success", {
              button: "Ok",
            })
            this.getTagCategory()
          }
          this.loadingButtonAdd = false
      })
      .catch(error => {
        swal("Sorry", error.response.data.message, "error", {
          button: "Ok",
        }).then(v => {
          if(error.response.data.status == 401) {
            this.handleLogout()
          }
        })
      })
    },
    cekPermission(){
      this.permission = localStorage.getItem('roles').replace(/"/g,"").replace("[","").replace("]","").split(",")
      for(var i=0; i < this.permission.length; i++){
        if( this.permission[i] == '20.2'){
          this.editTag = true
        }

      }
    },
    searchData(){
      this.$router.push({path:'/tag/order', query: {
            tagName:this.searchTagName,
            tagCategory: JSON.stringify(this.selectedFilterTagCategory),
            categoryName:this.searchCategoryName,
            page:1,
            categoryPage:1,
          }
      })
      this.getTag()
    },
    toDataPage(pagePost, type){
      if(type === 'category') {
        this.$router.push({path:'/tag/order', query: {
            tagName: this.searchTagName,
            tagCategory: JSON.stringify(this.selectedFilterTagCategory),
            categoryName: this.searchCategoryName,
            page:this.currentPage,
            categoryPage: pagePost
          }
        })
        this.getTagCategory()
      }

       if(type === 'tag') {
        this.$router.push({path:'/tag/order', query: {
            tagName: this.searchTagName,
            tagCategory: JSON.stringify(this.selectedFilterTagCategory),
            categoryName: this.searchCategoryName,
            page:pagePost,
            categoryPage: this.currentCategoryPage
          }
        })
        this.getTag()
      }
      
    },
    toPage(e) {
      this.$router.push(e)
    },
    async handleLogout() {
      try {
        const response = await this.$http.post(process.env.LOGOUT, {}, {
          headers: {
            'Asani-Token': localStorage.getItem('jwt')
          }
        })
        if (response.data.status !== 200) {
          swal("Sorry", response.data.message, "error", {
            button: "Ok",
          })
          return
        }

      } catch (error) {
        if(error.response.data.status != 401) {
          swal("Sorry", error.response.data.message, "error", {
            button: "Ok",
          })
          return
        }
      }
      localStorage.removeItem('jwt')
      localStorage.removeItem('admin_name')
      localStorage.removeItem('roles')
      localStorage.removeItem('user_email')
      localStorage.removeItem('admin_id')
      localStorage.removeItem('changeCatalogPermission')
      this.$router.push('/')
    },
    cekLogin(){
      if (localStorage.getItem('jwt') == null) {
        this.$router.push('/')
      }
    },
    sidebar(){
      $("#wrapper").toggleClass("toggled");
    },
    openModal(modalName,isTag,item, id, type) {
      console.log('id', id, this.financeTag.indexOf(id) >= 0)
      if (id) {
        if (type === 'tag' && this.financeTag.indexOf(id) >= 0) {
          swal("Error", "Finance tag tidak dapat di ubah atau di hapus!" , "error")
          return
        }
        if (type === 'category' && this.financeCategory.indexOf(id) >= 0) {
          swal("Error", "Finance tag tidak dapat di ubah atau di hapus!" , "error")
          return
        }
      }
      this.newTagCategory= ""
      this.newTagCategoryDefaultColor = ""
      if(item) {
        if(isTag) {
          this.selectedTag = item
          this.addTagName=item.label
          this.addTagColor = item.colorHex
          this.addTagCategory= item.category

          this.addCategoryName= ""
          this.addCategoryDefaultColor= ""
        } else {
          this.selectedCategory=item
          this.addCategoryName= item.categoryName
          this.addCategoryDefaultColor= item.categoryDefaultColor

          this.addTagName=""
          this.addTagColor = ""
          this.addTagCategory=""
        }
      } else {
          this.addTagName=""
          this.addTagColor = ""
          this.addTagCategory= ""

          this.addCategoryName= ""
          this.addCategoryDefaultColor= ""
      }
      $("#modal"+modalName).modal('show')
    },
    getTag(){
      this.loadingTagTable = true
      this.searchTagName = this.$route.query.tagName
      this.selectedFilterTagCategory =  []
      this.selectedFilterTagCategory = JSON.parse(this.$route.query.tagCategory)
      this.currentPage = parseInt(this.$route.query.page)

      var category = []
      for (var i = 0; i < this.selectedFilterTagCategory.length; i++) {
        category.push(this.selectedFilterTagCategory[i].categoryId)
      }
      this.$http.post(process.env.SEARCH_TAG,
      {
        target: "ORDER",
        label: this.searchTagName.replace(this.spaceRegex, ' '),
        categoryId: category,
        page: this.currentPage,
        itemPerPage: this.itemPerPage,
      },
      {
        headers: {'Asani-Token':localStorage.getItem('jwt')}
      })
      .then(response => {
        if (response.data.status == 400) {
              swal("Sorry", response.data.message, "error", {
                    button: "Ok",
                  })
            }else{
                // NOTE :
                // Type data.content = {
                //     currentPage: number,
                //     data : {
                //         "tagId": number,
                //         "label": string,
                      // "colorHex": "#00008B",
                //         category: {
                            //   "categoryId": 1,
                            //   "categoryName": "Sales",
                            //   "target": "ORDER",
                            //   "categoryDefaultColor": "#000000"
                            // }
                //     }[],
                //     totalData: number,
                //     totalPage: number,
                // }
          
              this.dataTag = response.data.content.data
              this.totalPage = response.data.content.totalPage
              this.totalData = response.data.content.totalData
              this.currentPage = response.data.content.currentPage
              this.loadingTagTable = false 
            }
      })
      .catch(error => {
        swal("Sorry", error.response.data.message, "error", {
          button: "Ok",
        }).then(v => {
          if(error.response.data.status == 401) {
            this.handleLogout()
          }
        })
      })
    },
    getTagCategory(){
      this.loadingCategoryTable = true
      this.searchCategoryName = this.$route.query.categoryName
      this.currentCategoryPage = parseInt(this.$route.query.categoryPage)
      this.getAllCategory()
      this.$http.post(process.env.SEARCH_TAG_CATEGORY,
      {
        target: "ORDER",
        categoryName: this.searchCategoryName.replace(this.spaceRegex, ' '),
        page: this.currentCategoryPage,
        itemPerPage: this.itemPerPage/2
      },
      {
        headers: {'Asani-Token':localStorage.getItem('jwt')}
      })
      .then(response => {
        if (response.data.status == 400) {
              swal("Sorry", response.data.message, "error", {
                    button: "Ok",
                  })
            }else{
                // NOTE :
                // Type data.content = {
                //     currentPage: number,
                //     data : {
                //         "tagId": number,
                //         "label": string,
                //         category: string,
                //         "colorHex": string,
                //         "createdAt": string,
                //         "createdBy": number,
                //         "updatedAt": string,
                //         "updatedBy": number,
                //     }[],
                //     totalData: number,
                //     totalPage: number,
                // }
              this.dataCategory = response.data.content.data
              this.totalCategoryPage = response.data.content.totalPage
              this.totalCategoryData = response.data.content.totalData
              this.currentCategoryPage = response.data.content.currentPage
              this.loadingCategoryTable = false 
            }
      })
      .catch(error => {
        swal("Sorry", error.response.data.message, "error", {
          button: "Ok",
        }).then(v => {
          if(error.response.data.status == 401) {
            this.handleLogout()
          }
        })
      })
    },
    getAllCategory(){
      this.$http.post(process.env.SEARCH_TAG_CATEGORY,
      {
        target: "ORDER",
        categoryName: "",
        page: 1,
        itemPerPage: 99999
      },
      {
        headers: {'Asani-Token':localStorage.getItem('jwt')}
      })
      .then(response => {
        if (response.data.status == 400) {
              swal("Sorry", response.data.message, "error", {
                    button: "Ok",
                  })
            }else{
              this.allCategoryData = response.data.content.data
              this.tagCategoryOptions = [...response.data.content.data,
              {
                categoryId: 0,
                categoryName: "Others",
                target: "LESSEE",
                categoryDefaultColor: ""
              }]
            }
      })
      .catch(error => {
        swal("Sorry", error.response.data.message, "error", {
          button: "Ok",
        }).then(v => {
          if(error.response.data.status == 401) {
            this.handleLogout()
          }
        })
      })
    },
  },
  created(){
    this.getTag()
    this.getTagCategory()
    this.admin = localStorage.getItem('admin_name')
    this.adminId = localStorage.getItem('admin_id')
    this.cekLogin()
    this.cekPermission()
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .error-field >>> .multiselect__tags{
    border-color: #f57f6c;
  }
.cekbox{
  margin-top: 6px;
  margin-right: 5px;
}

.name-search {
  min-height:42px;
}

.one-line{
  display: flex;
  margin: 5px 0px;
}

.one-line .ol-label{
  width: 188px;
  margin: 5px 0px;
}

.one-line .ol-labelCategory{
  width: 188px;
  margin: 7px 0px;
  margin-right: -2px;
}

.one-line .ol-label-price{
  width: 263px;
  margin: 2px 0px;
}

.one-line .ol-titik2{
  width: 15px;
  margin: 5px 0px;
}

.one-line .ol-titik2category{
  width: 15px;
  margin: 7px -1px;
}

.pagination{
padding: 0px 0;
}

.pagination ul{
margin: 0;
padding: 0;
list-style-type: none;
}

.pagination a{
display: inline-block;
padding: 1px 6px;
color: #222;
}

.p8 a{
background-color: #2797FB;
/*margin: auto 5px;*/
color: #fff;
/*font-weight: bold;*/
border: 1px solid #2797FB;
}

.p8 a:hover{
text-decoration: none;
}
.p8 a.page:hover{
text-decoration: none;
color: #fff;
}

.p8 .is-active{
background-color: #fff;
color: #2797FB;
}

.alignleft {
float: left;
}
.alignright {
float: right;
}

.pagg{
display: inline-flex;
overflow:auto;
}

.total-data{
padding: 11px 0px;
font-size: 14px;
color: #343A40;
}
#wrapperr{
  overflow:auto;
  margin: 5px 3px;
}

#c1{
 float:left;
}

#c2{
float: right;  
}

.border-red{
  border-color:red;
}

.search-table{
padding-bottom: 7px;
margin-top: -5px;
margin-left: -15px;
}

.active{
color: #2797FB;
}
.right-dropdown{
margin-left: 7px;
}
.account-div{
margin: 2px 2px;
}
.right-arrow{
margin-left: auto;
}
.brand-logo{
width: 120px;
}
.menu-title{
margin-left: 1.125rem;
}
.menu-title-order{
margin-left: 1.95rem;
}
.menu-title-payment{
margin-left: 1.525rem;
}

ul {
list-style-type: none;
margin: 0;
padding: 0;
/*width: 200px;*/
/*background-color: #f1f1f1;*/
}

li.sidebar a {
display: block;
color: #000;
padding: 8px 63px;
text-decoration: none;
}

li a.active {
background-color: #4CAF50;
color: white;
}

li a:hover:not(.active) {
background-color: #2797FB;
color: white;
}
.nav-side-menu {
overflow: auto;
font-family: verdana;
font-size: 12px;
font-weight: 200;
background-color: #2e353d;
position: fixed;
top: 0px;
width: 300px;
height: 100%;
color: #e1ffff;
}
.nav-side-menu .brand {
background-color: #23282e;
line-height: 50px;
display: block;
text-align: center;
font-size: 14px;
}
.nav-side-menu .toggle-btn {
display: none;
}
.nav-side-menu ul,
.nav-side-menu li {
list-style: none;
padding: 0px;
margin: 0px;
line-height: 35px;
cursor: pointer;
}
 .nav-side-menu ul :not(collapsed) .arrow:before,
 .nav-side-menu li :not(collapsed) .arrow:before {
  font-family: FontAwesome;
  content: "\f078";
  display: inline-block;
  padding-left: 10px;
  padding-right: 10px;
  vertical-align: middle;
}
.nav-side-menu ul .active,
.nav-side-menu li .active {
  border-left: 3px solid #d19b3d;
  background-color: #4f5b69;
}
.nav-side-menu ul .sub-menu li.active,
.nav-side-menu li .sub-menu li.active {
  color: #d19b3d;
}
.nav-side-menu ul .sub-menu li.active a,
.nav-side-menu li .sub-menu li.active a {
  color: #d19b3d;
}
.nav-side-menu ul .sub-menu li,
.nav-side-menu li .sub-menu li {
  background-color: #181c20;
  border: none;
  line-height: 28px;
  border-bottom: 1px solid #23282e;
  margin-left: 0px;
}
.nav-side-menu ul .sub-menu li:hover,
.nav-side-menu li .sub-menu li:hover {
  background-color: #020203;
}
.nav-side-menu ul .sub-menu li:before,
.nav-side-menu li .sub-menu li:before {
  font-family: FontAwesome;
  content: "\f105";
  display: inline-block;
  padding-left: 10px;
  padding-right: 10px;
  vertical-align: middle;
}
.nav-side-menu li {
  padding-left: 0px;
  border-left: 3px solid #2e353d;
  border-bottom: 1px solid #23282e;
}
.nav-side-menu li a {
  text-decoration: none;
  color: #e1ffff;
}
.nav-side-menu li a i {
  padding-left: 10px;
  width: 20px;
  padding-right: 20px;
}
.nav-side-menu li:hover {
  border-left: 3px solid #d19b3d;
  background-color: #4f5b69;
  -webkit-transition: all 1s ease;
  -moz-transition: all 1s ease;
  -o-transition: all 1s ease;
  -ms-transition: all 1s ease;
  transition: all 1s ease;
}

@media (max-width: 767px) {
  .nav-side-menu {
    position: relative;
    width: 100%;
    margin-bottom: 10px;
  }
  .nav-side-menu .toggle-btn {
    display: block;
    cursor: pointer;
    position: absolute;
    right: 10px;
    top: 10px;
    z-index: 10 !important;
    padding: 3px;
    background-color: #ffffff;
    color: #000;
    width: 40px;
    text-align: center;
  }
  .brand {
    text-align: left !important;
    font-size: 22px;
    padding-left: 20px;
    line-height: 50px !important;
  }
}
@media (min-width: 767px) {
  .nav-side-menu .menu-list .menu-content {
    display: block;
  }
}
@media (max-width: 573px){
  .mobile-div{
    padding: 2px 0px;
  }
}
</style>





// WEBPACK FOOTER //
// src/components/Tag/OrderTag.vue